import { buildProjection, useSettlements, useYtd } from '@/api';
import { LinkBanner, Page } from '@/components';
import { Box, Flex, Heading } from '@blockanalitica/ui';
import AnnualizedProjection from './AnnualizedProjection';
import SettlementHistoryChart from './SettlementHistoryChart';
import YtdKpis from './YtdKpis';

export default function FinancialsPage() {
  const [ytd, ytdError] = useYtd();
  const [settlements, settlementsError] = useSettlements();

  if (ytdError || settlementsError) {
    throw ytdError ?? settlementsError;
  }

  const projection = settlements ? buildProjection(settlements) : undefined;

  return (
    <Page title="Financials">
      <Flex flexDirection="column" gap="m">
        <LinkBanner
          text="View on financial.skyeco.com"
          linkTo="https://financial.skyeco.com/financials/revenue">
          <Box paddingTop="xs" paddingBottom="m" maxWidth="85%">
            <Heading size="2">Sky Core Financials</Heading>
            <br />
            Settlement-level summary of Sky&apos;s protocol financials, with an
            annualized run-rate projected from the most recent cycles. For the
            full statement, see P&L page on financial.skyeco.com.
          </Box>
        </LinkBanner>
        <YtdKpis data={ytd} />
        <SettlementHistoryChart rows={settlements} />
        <AnnualizedProjection data={projection} />
      </Flex>
    </Page>
  );
}
